<template>
  <div class="eol-slider-bar">
    <a-menu mode="inline" :selected-keys="selectedKeys" :open-keys="openKeys" @openChange="handleOpenChange">
      <template v-for="route in routes">
        <a-sub-menu v-if="route.children && route.children.length" :key="`/${school_code}${route.path}`" :class="route.icon">
          <template #title>
            <a-icon :type="route.icon" />
            <span>{{ route.name }}</span>
          </template>
          <template v-for="child in route.children">
            <template v-if="adminMenuKeys.some(item => item  == child.path) && (appsUserInfo.user_type == 2 || (appsUserInfo.user_type == 1 &&  appsUserInfo.role_ids == 2))">
              <a-menu-item :key="`/${school_code}${child.path}`">
                <router-link :to="`/${school_code}${child.path}`">{{ child.name }}</router-link>
              </a-menu-item>
            </template>
            <!-- <a-menu-item v-else :key="'/'+school_code+child.path">
              <router-link :to="'/'+school_code+child.path">{{ child.name }}</router-link>
            </a-menu-item> -->
            <a-menu-item v-if="adminMenuKeys.every(item => item  != child.path)" :key="`/${school_code}${child.path}`">
              <router-link :to="`/${school_code}${child.path}`">{{ child.name }}</router-link>
            </a-menu-item>
          </template>
        </a-sub-menu>
        <a-menu-item v-else :key="`/${school_code}${route.path}`" :class="route.icon">
          <router-link :to="`/${school_code}${route.path}`">
            <a-icon :type="route.icon" />
            <span>{{ route.name }}</span>
          </router-link>
        </a-menu-item>
      </template>
    </a-menu>
  </div>
</template>

<script>
import { schoolRoutes } from '../../src/utils/template';
import { mapState } from "vuex";
export default {
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      routes: schoolRoutes,
      openKeys: [],
      selectedKeys: [],
      adminMenuKeys: ['/school/system/admin', "/school/hsjr/stadiumType", "/school/hsjr/stadiumAddress"],
    };
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  created() {
    this.updateMenuState(this.$route.path);
    this.filterRoutes();
  },
  watch: {
    // 监听路由变化，动态更新选中的菜单和展开的菜单
    $route(to) {
      this.updateMenuState(to.path);
    }
  },
  methods: {
    handleOpenChange(keys) {
      this.openKeys = keys;
    },
    updateMenuState(path) {
      // 计算 openKeys，找到 path 对应的所有父级菜单
      this.routes.forEach(route => {
        if (path.indexOf(route.path) > -1) {
          let activePath = '/' + this.school_code + route.path
          this.openKeys = [activePath];
          this.selectedKeys = [activePath, path];
        }
      });
    },
    filterRoutes() {
      if (this.school_code != "100029") {
        this.routes = this.routes.filter(route => {
          return route.name != "红色金融实践"
        });
      }

    }
  }
};
</script>

<style lang="less" scoped>
.eol-slider-bar {
  position: fixed;
  width: 180px;
  background: #fff;
  left: 0;
  overflow-x: hidden;
  top: 70px;
  height: calc(100vh - 70px);
  overflow-y: auto;
  z-index: 999;
  /deep/ .ant-menu {
    .ant-menu-item.appstore {
      &.ant-menu-item-selected {
        .anticon {
          background-image: url("../../assets/image/school/slider/practice-active.png");
        }
      }
      .anticon {
        background-image: url("../../assets/image/school/slider/practice.png");
        width: 14px;
        height: 13px;
        background-size: cover;
        svg {
          display: none;
        }
      }
    }
    .ant-menu-submenu {
      &.folder {
        .anticon {
          background-image: url("../../assets/image/school/slider/resource.png");
          width: 14px;
          height: 13px;
          background-size: cover;
          svg {
            display: none;
          }
        }
      }
      &.setting {
        .anticon {
          background-image: url("../../assets/image/school/slider/system.png");
          width: 14px;
          height: 13px;
          background-size: cover;
          svg {
            display: none;
          }
        }
      }
      &.cases {
        .anticon {
          background-image: url("../../assets/image/school/slider/case-default.png");
          width: 14px;
          height: 13px;
          background-size: cover;
          svg {
            display: none;
          }
        }
      }
    }
  }
}
</style>
